import { styled } from '@mui/material';
import { Grid } from '@mui/system';

export const PREFIX = 'UserFormSkeleton';

export const userFormSkeletonClasses = {
  media: `${PREFIX}-media`,
  input: `${PREFIX}-input`,
};

export const UserFormStyledGrid = styled(Grid)(({ theme }) => ({
  [`& .${userFormSkeletonClasses.media}`]: {
    height: 140,
  },

  [`& .${userFormSkeletonClasses.input}`]: {
    height: 40,
    margin: theme.spacing(1),
  },
}));